<mat-form-field [formGroup]="group" [appearance]="appearance">
  <mat-label>{{field?.localeText?.name}}</mat-label>
  <span>
    <input matInput [formControlName]="field.fieldKey" [placeholder]="field.localeText.name" [type]="'password'"
      [required]="field.required" showHidePWD>
  </span>
  <ng-container *ngFor="let item of group.get(field.fieldKey).errors | keys:1" ngProjectAs="mat-error">
    <mat-error>
      {{field.validation  | error:item.key }}
    </mat-error>
  </ng-container>
</mat-form-field>
